import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { authInfoReselector as stateSelector } from 'reduxModules/auth/selectors'
import { accountDispatch as dispatcher } from 'reduxModules/auth/dispatchers'
import 'rodal/lib/rodal.css'
import template from './template.rt'
import './styles.css'

export class MyAccount extends React.Component {
  constructor(props) {
    super(props)
    this.confirmPayment = this.confirmPayment.bind(this)
  }

  confirmPayment() {
    this.props.dispatchCancelFreeTrial(true, this.props.usedFreeTrial)
  }

  render() {
    return template.call(this)
  }
}

MyAccount.propTypes = {
  couldGiftSubscription: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  subscription: PropTypes.shape({
    plan: PropTypes.string.isRequired,
    free: PropTypes.bool.isRequired,
    rank: PropTypes.number.isRequired
  }),
  dispatchCancelSubscription: PropTypes.func.isRequired
}

MyAccount.defaultProps = {
  firstName: '',
  lastName: '',
  subscription: null
}

export default connect(
  stateSelector,
  dispatcher
)(MyAccount)
